if (!customElements.get('video-controls')) {
  customElements.define(
    'video-controls',
    class VideoControls extends HTMLElement {
      constructor() {
        super();

        this.play = this.querySelector('[data-control="play-pause"]');
        this.mute = this.querySelector('[data-control="mute-unmute"]');
        this.target = null;

        this.handlePlay = this.updateButtonStates.bind(this);
        this.handlePause = this.updateButtonStates.bind(this);
        this.handleVolumeChange = this.updateButtonStates.bind(this);

        if (this.play) {
          this.play.addEventListener('click', () => this.togglePlayPause());
        }

        if (this.mute) {
          this.mute.addEventListener('click', () => this.toggleMute());
        }
      }

      connectedCallback() {
        this.findTarget();
        this.updateButtonStates();
        this.setupVideoListeners();
      }

      disconnectedCallback() {
        this.removeVideoListeners();
      }

      setupVideoListeners() {
        if (!this.target || !(this.target instanceof HTMLVideoElement)) return;

        this.target.addEventListener('play', this.handlePlay);
        this.target.addEventListener('pause', this.handlePause);
        this.target.addEventListener('volumechange', this.handleVolumeChange);
      }

      removeVideoListeners() {
        if (!this.target || !(this.target instanceof HTMLVideoElement)) return;

        this.target.removeEventListener('play', this.handlePlay);
        this.target.removeEventListener('pause', this.handlePause);
        this.target.removeEventListener('volumechange', this.handleVolumeChange);
      }

      findTarget() {
        const video = this.closest('section')?.querySelector('video');

        if (video) {
          this.target = video;
          this.updateButtonStates();
        }
      }

      togglePlayPause() {
        if (!this.target) return;

        if (this.target instanceof HTMLVideoElement) {
          if (this.target.paused) {
            this.target.play();
          } else {
            this.target.pause();
          }
        }
      }

      toggleMute() {
        if (!this.target) return;

        if (this.target instanceof HTMLVideoElement) {
          this.target.muted = !this.target.muted;
        }
      }

      updateButtonStates() {
        if (!this.target || !(this.target instanceof HTMLVideoElement)) {
          if (this.play) {
            this.play.setAttribute('disabled', '');
          }
          if (this.mute) {
            this.mute.setAttribute('disabled', '');
          }
          return;
        }

        if (this.play) {
          this.play.removeAttribute('disabled');

          const playState = this.target.paused ? 'Play' : 'Pause';
          this.play.setAttribute('aria-label', `${playState} video`);
          this.play.setAttribute('data-state', this.target.paused ? 'play' : 'pause');

          const buttonText = this.play.querySelector('.button-text');
          if (buttonText) {
            buttonText.textContent = playState;
          }
        }

        if (this.mute) {
          this.mute.removeAttribute('disabled');
          const muteState = this.target.muted ? 'Unmute' : 'Mute';
          this.mute.setAttribute('aria-label', `${muteState} video`);
          this.mute.setAttribute('data-state', this.target.muted ? 'unmute' : 'mute');

          const buttonText = this.mute.querySelector('.button-text');
          if (buttonText) {
            buttonText.textContent = muteState;
          }
        }
      }
    },
  );
}
